<template>
  <div id="I-APC-RM">
    <vs-row vs-w="12">
      <vs-row vs-w="12" vs-type="flex">
        <vs-col
          vs-w="12"
          vs-lg="3"
          vs-sm="12"
          vs-xs="12"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
        >
          <!-- <vs-card>status gete</vs-card> -->
          <CardSensor />
        </vs-col>
        <vs-col vs-w="12" vs-lg="9" vs-sm="12" vs-xs="12" vs-type="flex">
          <vs-row vs-w="12" vs-type="flex">
            <vs-row vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12" vs-type="flex">
              <vs-col vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12" vs-type="flex">
                <!-- <vs-card>total work today</vs-card> -->
                <CardTotalStock  />
              </vs-col>
              <vs-col vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12" vs-type="flex">
                <!-- <vs-card>total active</vs-card> -->
                <CardNewItem  />
              </vs-col>
            </vs-row>
            <vs-row vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12" vs-type="flex">
              <vs-col vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12" vs-type="flex">
                <!-- <vs-card>chart total hour today</vs-card> -->
                <!-- <CardChartTatalWork /> -->
                <CardAddItem />
              </vs-col>
            </vs-row>
          </vs-row>
        </vs-col>
      </vs-row>

      <!-- <vs-row vs-w="12" vs-type="flex" v-if="$store.getters['unicorn/dataTable'].length >= 0"> -->
      <vs-row vs-w="12" vs-type="flex">

        <vs-col>
          <!-- <vs-card>horizontal list</vs-card> -->
          <!-- <CardListEmployee/> -->
          <CardTable />
        </vs-col>
      </vs-row>
    </vs-row>
  </div>
</template>

<script>
// import libery
import moment from "moment";

// import component
import CardSensor from "./components/CardSensor.vue";
import CardTotalStock from "./components/CardTotalStock.vue";
import CardNewItem from "./components/CardNewItem.vue";
import CardAddItem from "./components/CardAddItem.vue";
import CardTable from "./components/CardTable.vue";

export default {
  components: {
    CardSensor,
    CardTotalStock,
    CardNewItem,
    CardAddItem,
    CardTable,
  },
  data() {
    return {
      totalStock: 0,
      newStockToday: 0,
      rawData: {},
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {

      // call method in store
      this.$store.dispatch('unicorn/getData')

    },
  },
};
</script>

<style>
</style>